[
  {
    "code": "AT-1",
    "name": "Burgenland"
  },
  {
    "code": "AT-2",
    "name": "Kärnten"
  },
  {
    "code": "AT-3",
    "name": "Niederösterreich"
  },
  {
    "code": "AT-4",
    "name": "Oberösterreich"
  },
  {
    "code": "AT-5",
    "name": "Salzburg"
  },
  {
    "code": "AT-6",
    "name": "Steiermark"
  },
  {
    "code": "AT-7",
    "name": "Tirol"
  },
  {
    "code": "AT-8",
    "name": "Vorarlberg"
  },
  {
    "code": "AT-9",
    "name": "Wien"
  }
]